import { createAsyncThunk } from '@reduxjs/toolkit';

import { ApiPaths } from '../../dataProvider/APIPaths';
import APIDataProvider from '../../dataProvider/APIDataProvider';
import { ILimitation, IUserUsage } from '.';
import { IUser } from '../UserSlice';

interface ISaveUsage {
  userId: string;
  option: string;
}

interface IAccessLimit {
  usage: IUserUsage;
  limitation: ILimitation;
  lpAccess: boolean;
}

interface ISaveUserDetails {
  userId: string;
  email?: string;
  fullName: string;
  phoneNumber: string;
  country: string;
}

export const UserUsageApiDataProvider = new APIDataProvider<IUserUsage>();
export const AccessLimitApiDataProvider = new APIDataProvider<IAccessLimit>();
export const UserDetailsApiDataProvider = new APIDataProvider<IUser>();

export const getUsageByUserId = createAsyncThunk(
  'access/usage/get',
  async (userId: string) => {
    const response = await AccessLimitApiDataProvider.getById(
      `${ApiPaths.usage}/${userId}`
    );
    return response.data;
  }
);

export const saveUserUsage = createAsyncThunk(
  'access/usage/save',
  async (data: ISaveUsage) => {
    const response = await UserUsageApiDataProvider.create(
      `${ApiPaths.usage}`,
      data
    );
    return response.data;
  }
);

export const saveUserDetails = createAsyncThunk(
  'access/userDetails/create',
  async (data: ISaveUserDetails) => {
    const response = await UserDetailsApiDataProvider.create(
      `${ApiPaths.usage}/userDetails`,
      data
    );
    return response.data;
  }
);
